module.exports = __webpack_public_path__ + "static/media/messenger.83e553a5.svg";